function getQueryParams(data) {
  const params = Object.keys(data).reduce((acc, param) => {
    const value = data[param]
    if (value != null) {
      acc.push(`${param}=${encodeURIComponent(value)}`)
    }
    return acc
  }, [])
  return params.join('&')
}

export default getQueryParams
